import {
	Box,
	Button,
	Container,
	Flex,
	Heading,
	Image,
	SimpleGrid,
	Stack,
	Text,
} from '@chakra-ui/react'
import { Link as RemixLink } from '@remix-run/react'

const srd04DemoUrl = '/procedimenti/istruttoria_dds_srd04/12348/lista-fasi'
const chatbotUrl = process.env.SIARC_DEMO_URL || 'http://siarc-demo.regione.campania.it:8081'

export default function Home() {
	return (
		<Container maxW="6xl" px={{ base: 0, md: 4 }}>
			<Box
				as="section"
				bg="white"
				border="1px solid"
				borderColor="gray.200"
				borderTop="6px solid"
				borderTopColor="primary.100"
				borderRadius="md"
				boxShadow="sm"
				overflow="hidden"
			>
				<Flex
					align={{ base: 'flex-start', md: 'center' }}
					justify="space-between"
					gap={8}
					p={{ base: 6, md: 10 }}
					direction={{ base: 'column', md: 'row' }}
				>
					<Stack spacing={5} maxW="3xl">
						<Box>
							<Text
								as="p"
								color="primary.100"
								fontSize="sm"
								fontWeight="700"
								letterSpacing="0"
								textTransform="uppercase"
								mb={2}
							>
								Regione Campania
							</Text>
							<Heading
								as="h1"
								color="gray.800"
								fontSize={{ base: '3xl', md: '4xl' }}
								fontWeight="700"
								lineHeight="1.15"
								letterSpacing="0"
							>
								SIARC
							</Heading>
						</Box>

						<Text color="gray.700" fontSize={{ base: 'lg', md: 'xl' }} lineHeight="1.6">
							Sistema Informativo Agricolo Regionale per la gestione dei procedimenti e dei servizi
							dedicati agli operatori.
						</Text>
					</Stack>

					<Image
						src="/img/logoSiarcNoBordo.png"
						alt="Logo SIARC"
						maxW={{ base: '160px', md: '220px' }}
						objectFit="contain"
						alignSelf={{ base: 'center', md: 'center' }}
					/>
				</Flex>

				<Box borderTop="1px solid" borderColor="gray.200" bg="gray.50" p={{ base: 6, md: 8 }}>
					<SimpleGrid columns={{ base: 1, md: 2 }} spacing={4} maxW="2xl">
						<Button
							as={RemixLink}
							to={srd04DemoUrl}
							colorScheme="pa"
							size="lg"
							minH="48px"
							justifyContent="center"
							_focusVisible={{
								boxShadow: '0 0 0 3px rgba(0, 102, 204, 0.35)',
							}}
						>
							Accedi alla demo SRD04
						</Button>

						{chatbotUrl ? (
							<Button
								as={RemixLink}
								to={chatbotUrl}
								variant="outline"
								color="primary.100"
								borderColor="primary.100"
								size="lg"
								minH="48px"
								justifyContent="center"
								_focusVisible={{
									boxShadow: '0 0 0 3px rgba(0, 102, 204, 0.35)',
								}}
							>
								Accedi al chatbot
							</Button>
						) : null}
					</SimpleGrid>
				</Box>
			</Box>
		</Container>
	)
}
